import React, { Component } from 'react';
import { withStyles, Card, CardHeader, CardContent, CardMedia, IconButton, Theme, TextField, CardActions, Tooltip, Button, Grid } from '@material-ui/core';
import { red } from '@material-ui/core/colors';
import InsertPhotoIcon from '@material-ui/icons/InsertPhoto';
import UnfoldLessIcon from '@material-ui/icons/UnfoldLess';
import ViewComfyIcon from '@material-ui/icons/ViewComfy';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ADD_POST, UPDATE_FEATUREDPOST, UPDATE_POST } from '../../core/handlers.actions';
import { User } from '../../core/models/user';
import { TrixEditor } from 'react-trix';
import 'trix/dist/trix';
import 'trix/dist/trix.css';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import StarIcon from '@material-ui/icons/Star';
import { withRouter } from 'react-router-dom';
import { IWall } from '../../core/models/wall';

const styles = (theme: Theme) => ({
    rootInput: {
        '& > *': {
            margin: theme.spacing(1),
        }
    },
    root: {
        maxWidth: 900,
        // marginBottom: theme.spacing(100),
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    avatar: {
        backgroundColor: red[500],
    },
    featuredPost: {
        color: 'gold'
    }
});

interface Props {
    classes: any;
    action: () => void;
    tags?: any;
    tagsRef?: any;
    featuredTag?: any;
    uploadPost: (post: any) => void;
    editPost: (post: any) => void;
    user: User;
    edit: boolean;
    post?: any;
    match: any;
    location: any;
    history: any;
    walls: any;
    postUpdateFeatured: (data: any) => void;
}

interface State {
    image: string | null;
    title: string | null;
    description: string | null;
    isTruncated: boolean;
    imageErrorMessage: boolean;
    layout: number;
    isNewImage: boolean;
    _id: string | null;
    postImage: string | null;
    isApproved: boolean;
    isFeatured: boolean;
}

class AddEditPostCard extends Component<Props, State>{
    state: State = {
        image: null,
        layout: 1,
        title: '',
        description: '',
        isTruncated: false,
        imageErrorMessage: false,
        isNewImage: false,
        _id: null,
        postImage: null,
        isApproved: true,
        isFeatured: false
    }

    constructor(props: Props) {
        super(props);
        this.uploadImage = this.uploadImage.bind(this);
        this.inputHandleChange = this.inputHandleChange.bind(this);
        this.layoutHandle = this.layoutHandle.bind(this);
        this.renderPostLayout = this.renderPostLayout.bind(this);
        this.uploadPostHandler = this.uploadPostHandler.bind(this);
        this.truncateHandler = this.truncateHandler.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.approveHandler = this.approveHandler.bind(this);
        this.makePostFeatured = this.makePostFeatured.bind(this);
    }

    componentDidMount() {
        const { edit, post, match, walls } = this.props;
        const wallId = match.params.id || false;
        const wall = walls.find((wall: IWall) => wall._id === wallId);

        if (edit) {
            const isFeatured = wall? wall.featuredPosts.some((ids: any) => ids.id === post._id):false;
            this.setState({ ...this.state, isFeatured: isFeatured, _id: post?._id || '', postImage: post?.postImage || '', image: post?.postImage || '', layout: post?.layout || 1, title: post?.title || '', description: post?.description || '', isTruncated: post?.isTruncated || false, isApproved: post?.isApproved });
        }
    }

    public handleChange(html: any, text: any) {
        this.setState({ ...this.state, description: html });
    }

    public uploadImage(e: any) {
        const fileSizeLimit = 5 * 1048576; // 10MB
        const fileReader = new FileReader();
        if (e.target.files[0] > fileSizeLimit) return this.setState({ ...this.state, imageErrorMessage: true });
        fileReader.readAsDataURL(e.target.files[0]);
        fileReader.onload = (e: any) => this.setState({ ...this.setState, image: e.target.result, isNewImage: true });
    }

    public inputHandleChange(e: any) {
        const { name, value } = e.target
        this.setState({ ...this.state, [name]: value });
    }

    public layoutHandle() {
        const { layout } = this.state;
        const type = (layout === 1 || layout === 2) ? layout + 1 : 1;
        this.setState({ ...this.state, layout: type });
    }

    public approveHandler() {
        const { isApproved } = this.state;
        this.setState({ ...this.state, isApproved: !isApproved });
    }

    public truncateHandler() {
        this.setState({ ...this.state, isTruncated: !this.state.isTruncated });
    }

    public renderPostLayout() {
        const { classes } = this.props;
        const { layout, image, title } = this.state;
        const { description } = this.props.post || this.state.description;
        switch (layout) {
            case 1:
                return (
                    <div>
                        <CardHeader title={<TextField name="title" value={title} label="Title" onChange={this.inputHandleChange} />} />
                        {(image) ? (<CardMedia className={classes.media} image={image} title="post image" />) : null}
                        <CardContent>
                            <TrixEditor name="description" autoFocus={false} placeholder="Write something..." onChange={this.handleChange} value={description} />
                        </CardContent>
                    </div>
                );
            case 2:
                return (
                    <div>
                        {(image) ? (<CardMedia className={classes.media} image={image} title="post image" />) : null}
                        <CardHeader title={<TextField name="title" value={title} label="Title" onChange={this.inputHandleChange} />} />
                        <CardContent>
                            <TrixEditor name="description" autoFocus={false} placeholder="Write something..." onChange={this.handleChange} value={description} />
                        </CardContent>
                    </div>
                );
            default:
                return (
                    <div>
                        <CardHeader title={<TextField name="title" value={title} label="Title" onChange={this.inputHandleChange} />} />
                        <CardContent>
                            <TrixEditor name="description" autoFocus={false} placeholder="Write something..." onChange={this.handleChange} value={description} />
                        </CardContent>
                        {image ? (<CardMedia className={classes.media} image={image} title="post image" />) : null}
                    </div>
                );
        }
    }

    public uploadPostHandler() {
        const { title, description, layout, isTruncated, isNewImage, _id, image, postImage, isApproved } = this.state;
        const { uploadPost, user, action, edit, editPost, tags, featuredTag, tagsRef } = this.props;
        const userId = user.id;
        const userMetadata = { type: 'admin', description: 'created by admin', name: user.name };
        const post = { title, description, layout, tags, userId, isTruncated, userMetadata, _id, isNewImage, image, postImage, tagsRef, featuredTag, isApproved };
        // return console.log(post);
        edit ? editPost(post) : uploadPost(post);
        action();
    }

    public makePostFeatured() {
        const { postUpdateFeatured, match, walls, post } = this.props;
        const { isFeatured } = this.state;
        const wallId = match.params.id || false;
        const wall = walls.find((wall: IWall) => wall._id === wallId);
        const type = isFeatured ? false : true;
        postUpdateFeatured({ wallId: wallId, postId: post._id, type: type, position: wall?.featuredPosts.length });
        this.setState({...this.state, isFeatured: !isFeatured});
    }

    public render() {
        const { classes, action, edit } = this.props;
        const { isTruncated, isApproved, isFeatured } = this.state;

        return (
            <Card className={classes.root}>
                <CardActions disableSpacing className={'edit-card-actions'}>   
                    <Grid container spacing={2}>    
                        <Grid item>       
                            <label htmlFor="upload-image-button"><Tooltip title="Upload Image"><IconButton component="span" arial-label="Add image"><InsertPhotoIcon /></IconButton></Tooltip></label>               
                        </Grid>   
                        <Grid item>    
                            <Tooltip title="Truncate description"><IconButton aria-label="Truncate" onClick={this.truncateHandler}> <UnfoldLessIcon color={isTruncated? 'primary': 'inherit'} /></IconButton></Tooltip>  
                        </Grid>  
                        <Grid item>    
                            <Tooltip title="Post Layout"><IconButton aria-label="post layout"  onClick={this.layoutHandle}> <ViewComfyIcon /></IconButton></Tooltip>     
                        </Grid>                  
                    {edit? 
                    <Grid item> 
                        <Tooltip title="Approve Post"><IconButton aria-label="approve post" onClick={this.approveHandler}> <ThumbUpIcon color={!isApproved?'secondary': 'primary'} /></IconButton></Tooltip>    
                    </Grid>  
                    :null}          
                        <Grid item>    
                            <Tooltip className={classes.featuredButton} title="Make it featured"><IconButton onClick={this.makePostFeatured}><StarIcon className={(isFeatured)? classes.featuredPost : ''}/></IconButton></Tooltip> 
                        </Grid>  
                        <Grid item>    
                            <Tooltip title="Publish/Update Post"><Button variant="contained" aria-label="upload post" color="primary" onClick={this.uploadPostHandler}> {edit? 'Update!': 'Publish!'}</Button></Tooltip> 
                        </Grid>  
                        <Grid item>    
                            <Tooltip title="Cancel"><Button variant="contained" color="secondary" aria-label="Cancel" onClick={action}>Cancel!</Button></Tooltip>        
                        </Grid> 
                    </Grid> 
                </CardActions> 
                <input style={{ display: "none" }} accept="image/*" className={classes.input} id="upload-image-button" multiple type="file" onChange={this.uploadImage} /> 
                { this.renderPostLayout() }                                                   
            </Card >
        );
    }
}
const mapProps = (app: any) => ({
    user: app.rootReducer.user,
    walls: app.rootReducer.walls
});
const mapDispatch = (dispatch: Dispatch) => ({
    uploadPost: (post: any) => dispatch({ type: ADD_POST, payload: post }),
    editPost: (post: any) => dispatch({ type: UPDATE_POST, payload: post }),
    postUpdateFeatured: (data: any) => dispatch({ type: UPDATE_FEATUREDPOST, payload: data })
});

export default withRouter(connect(mapProps, mapDispatch)(withStyles(styles)(AddEditPostCard)));